import React, { useState } from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import DataTable from '../../components/common/DataTable';
import Modal from '../../components/common/Modal';
import { generateId } from '../../utils/helpers';

function ClassList() {
  const { classes, setClasses, staff, students } = useApp();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name:'', section:'A', roomNumber:'', capacity:'40', academicYear:'2025-2026', classTeacherId:'' });
  const [editing, setEditing] = useState(null);

  const openAdd = () => { setForm({ name:'', section:'A', roomNumber:'', capacity:'40', academicYear:'2025-2026', classTeacherId:'' }); setEditing(null); setModal(true); };
  const openEdit = (c) => { setForm(c); setEditing(c); setModal(true); };
  const remove = (id) => { if(window.confirm('Delete class?')) setClasses(prev=>prev.filter(c=>c.id!==id)); };

  const save = () => {
    if (editing) setClasses(prev=>prev.map(c=>c.id===editing.id?{...form,id:editing.id,subjectIds:editing.subjectIds||[],studentIds:editing.studentIds||[]}:c));
    else setClasses(prev=>[...prev,{...form,id:generateId('CLS'),subjectIds:[],studentIds:[]}]);
    setModal(false);
  };

  const getTeacher = (id) => { const s=staff.find(s=>s.id===id); return s?`${s.firstName} ${s.lastName}`:'-'; };
  const getStudentCount = (c) => students.filter(s=>s.classId===c.id).length;

  const columns = [
    { label: 'Class', key:'cls', render: c=><div className="font-semibold">{c.name} - Section {c.section}</div> },
    { label: 'Room', accessor:'roomNumber' },
    { label: 'Capacity', accessor:'capacity' },
    { label: 'Students', key:'stud', render: c=><span className="bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full font-medium">{getStudentCount(c)}</span> },
    { label: 'Class Teacher', key:'ct', render: c=>getTeacher(c.classTeacherId) },
    { label: 'Academic Year', accessor:'academicYear' },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Classes</h1><p className="text-gray-500 text-sm">{classes.length} classes this year</p></div>
        <button onClick={openAdd} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>Add Class</button>
      </div>
      <DataTable columns={columns} data={classes}
        actions={row=><>
          <button onClick={()=>openEdit(row)} className="p-1.5 hover:bg-indigo-50 rounded-lg text-indigo-600"><Edit2 size={15}/></button>
          <button onClick={()=>remove(row.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-500"><Trash2 size={15}/></button>
        </>}
      />
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Class':'Add New Class'}>
        <div className="space-y-3">
          {[['Class Name','name','text'],['Section','section','text'],['Room Number','roomNumber','text'],['Capacity','capacity','number'],['Academic Year','academicYear','text']].map(([label,key,type])=>(
            <div key={key}>
              <label className="block text-sm font-medium mb-1">{label}</label>
              <input type={type} value={form[key]||''} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))}
                className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
            </div>
          ))}
          <div>
            <label className="block text-sm font-medium mb-1">Class Teacher</label>
            <select value={form.classTeacherId||''} onChange={e=>setForm(f=>({...f,classTeacherId:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              <option value="">Select Teacher</option>
              {staff.filter(s=>s.designation==='Teacher'||s.designation==='Senior Teacher').map(s=><option key={s.id} value={s.id}>{s.firstName} {s.lastName}</option>)}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Save</button>
        </div>
      </Modal>
    </div>
  );
}
export default ClassList;
